import { Component } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-logo",
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: "./logo.component.html",
})
export class LogoComponent {}
